import { create } from 'zustand';
import { features as defaultFeatures, FeatureFlags } from '../config/features';

interface FeatureState extends FeatureFlags {
  override: (flags: Partial<FeatureFlags>) => void;
  reset: () => void;
}

export const useFeatureStore = create<FeatureState>(set => ({
  ...defaultFeatures,
  override: (flags: Partial<FeatureFlags>) => set(state => ({ ...state, ...flags })),
  reset: () => set(defaultFeatures),
}));
